/** Resolve cross-map links without waking the application server. */
export async function fetchPublicLinkStatuses(targetIds, base, { signal, fetcher = fetch } = {}) {
  const items = [];
  // Bound concurrency so a map with many references does not flood the edge.
  for (let offset = 0; offset < targetIds.length; offset += 8) {
    const batch = await Promise.all(targetIds.slice(offset, offset + 8).map(async (targetId) => {
      const response = await fetcher(`${base}/${encodeURIComponent(targetId)}.json`, { credentials: "omit", signal });
      if (response.status === 404) return { target_map_id: targetId, state: "restricted_or_unavailable" };
      if (!response.ok) throw new Error(`Public map availability failed: ${response.status}`);
      return response.json();
    }));
    items.push(...batch);
  }
  return items;
}

/** Only gallery routes on this website can be used as return destinations. */
export function getGalleryReturnUrl(search) {
  const params = new URLSearchParams(search);
  if (params.get("from") !== "gallery") return null;
  const candidate = params.get("gallery") || "/gallery";
  try {
    const url = new URL(candidate, "https://knowmapped.com");
    if (url.origin !== "https://knowmapped.com" || !/^\/gallery(?:\/browse|\/topics\/[a-z0-9-]{1,64})?$/.test(url.pathname)) return "/gallery";
    return `${url.pathname}${url.search}${url.hash}`;
  } catch { return "/gallery"; }
}
